// extracted by mini-css-extract-plugin
export var ignore = "_6t-1";
export var mapping = "_6t-0";
export var range = "_6t-4";
export var savings = "_6t-3";
export var settings = "_6t-2";